<template>
  <div id="main"  style="min-width:900px;" >
    <div  class="pkg-search-box">
      <el-form class="pkg-content"
               label-position="top"
               :model="dataForm"
               @keyup.enter.native="getDataListMerge()">
        <el-row class="margb10">
          <el-col :span="7">
            <el-form-item label="当前经销商"  class="search-item">
              <el-select v-model="dataForm.dealerId"
                         remote
                         clearable
                         filterable
                         reserve-keyword
                         :placeholder="$t('user.input')"
                         :remote-method="parentDealerSearch">
                <el-option v-for="item in parentDealerList"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="姓名"  class="search-item">
              <el-input v-model="dataForm.userName" clearable placeholder="请输入用户ID/姓名/员工号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="课程完成情况"  class="search-item">
              <el-select v-model="dataForm.courseFinishStatus"
                         clearable
                         :placeholder="$t('user.select')">
                <el-option v-for="(item,index) in trainingStatus"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <el-col :span="24">
              <el-button class="M-search"
                         style="margin-bottom: 7px"
                         type="primary"
                         @click="getDataListMerge">{{$t('course.query')}}
              </el-button>
            </el-col>

            <!-- 重置 -->
            <el-col :span="24">
              <el-button class="el-back M-search M-margin-l"
                         type="info"
                         @click="again">{{$t('reset')}}
              </el-button>
            </el-col>
          </el-col>
        </el-row>
        <!-- ---->
        <el-row class="margb10">
          <el-col :span="7">
            <el-form-item label="区域反馈"  class="search-item">
              <el-select v-model="dataForm.achievementCompetencyResult"
                         clearable
                         :placeholder="$t('user.select')">
                <el-option v-for="(item,index) in achievementCompetencyResult"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="发展截止日期"  class="search-item">
              <el-date-picker
                      v-model="dataForm.developEndTime"
                      type="daterange"
                      value-format="yyyy-MM-dd"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>


          <el-col :span="3">

          </el-col>
        </el-row>

        <!-- 高级搜索 --->
        <div v-show="moreList">
          <el-row class="margb10" >
            <el-col :span="7">
              <el-form-item label="评估职位"  class="search-item">
                <el-select v-model="dataForm.positionId"
                           clearable
                           :placeholder="$t('user.select')">
                  <el-option v-for="(item,index) in keyPositionArrs"
                             :key="index"
                             :label="item.positionCode + '-' +item.positionName"
                             :value="item.positionId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="当前经销商集团"  class="search-item">
                <el-select v-model="dataForm.dealerGroupId"
                           remote
                           clearable
                           filterable
                           reserve-keyword
                           :placeholder="$t('user.input')"
                           :remote-method="parentDealerGroupSearch">
                  <el-option v-for="item in parentDealerGroupList"
                             :key="item.orgId"
                             :label="item.name"
                             :value="item.orgId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!--区域 -->
            <el-col :span="7">
              <el-form-item label="区域"  class="search-item">
                <el-select v-model="dataForm.areaCode"
                           clearable
                           :placeholder="$t('user.select')">
                  <el-option v-for="(item,index) in area"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="margb10">
            <el-col :span="7">
              <!--品牌 -->
              <el-form-item class="search-item" label="当前品牌">
                <el-select v-model="dataForm.brandCode"
                           clearable
                           :placeholder="$t('user.select')">
                  <el-option v-for="(item,index) in brandCode"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="能力评估状态"  class="search-item">
                <el-select v-model="dataForm.assessmentStatus"
                           clearable
                           :placeholder="$t('user.select')">
                  <el-option v-for="(item,index) in assessmentStatusArr"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="发展中心结果"  class="search-item">
                <el-select v-model="dataForm.developCenterResult"
                           clearable
                           :placeholder="$t('user.select')">
                  <el-option v-for="(item,index) in developCenterState"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <el-row style="text-align: center; margin-bottom: 10px;">
        <el-col :span="24">
          <div class="show-or-hide-icon"
               v-bind:class="{ 'el-icon-arrow-up': moreList,
                                         'el-icon-arrow-down': !moreList }"
               @click="moreList = !moreList">&nbsp;{{ moreList ? '收起' : '高级搜索' }}
          </div>
        </el-col>
      </el-row>

    </div>
    <div class="pkg-content">

      <div class="search">
        <!-- 导出 btnAdded -->
        <el-button type="primary"
                   @click="exportdevelopment">导出
        </el-button>
      </div>
      <!-- 表头动态展示 -->
      <el-table v-loading="dataListLoading"
                ref="multipleTable"
                :data="dataList"
                border
                :row-style="{height:48+'px'}"
                :cell-style="{padding:0+'px'}">

        <!--当前经销商 -->
        <el-table-column label="当前经销商"
                         prop="dealerName"
                         header-align="center"
                         align="center"
                         width="100"
                         :show-overflow-tooltip="true"
                         fixed>
        </el-table-column>
        <!--姓名-->
        <el-table-column label="姓名"
                         prop="userName"
                         header-align="center"
                         align="center"
                         :show-overflow-tooltip="true"
                         width="100"
                         fixed>
        </el-table-column>
        <!-- 评估职位 -->
        <el-table-column label="评估职位"
                         prop="positionName"
                         header-align="center"
                         align="center"
                         :show-overflow-tooltip="true"
                         fixed>
        </el-table-column>

        <!-- 课程完成情况 -->
        <el-table-column label="课程完成情况"
                         prop="courseFinishStatus"
                         header-align="center"
                         align="center"
                         width="120"
                         :show-overflow-tooltip="true"
        ></el-table-column>
        <!--业绩/能力反馈 -->
        <el-table-column label="区域反馈"
                         prop="achievementCompetencyResult"
                         header-align="center"
                         align="center"
                         width="120"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <!-- 发展中心结果 -->
        <el-table-column label="发展中心结果"
                         prop="developCenterResult"
                         header-align="center"
                         width="120"
                         :show-overflow-tooltip="true"
                         align="center"></el-table-column>
        <!-- 发展开始日期 -->
        <el-table-column label="发展开始日期"
                         prop="developStartTime"
                         header-align="center"
                         width="120"
                         :show-overflow-tooltip="true"
                         align="center"></el-table-column>
        <!-- 发展截止日期 -->
        <el-table-column label="发展截止日期"
                         prop="developEndTime"
                         header-align="center"
                         align="center"
                         width="120"
                         :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 评估中心结果 -->
        <!-- <el-table-column label="评估中心结果"
                         prop="assessmentResult"
                         header-align="center"
                         align="center"
                         width="120"
                         :show-overflow-tooltip="true"
        ></el-table-column> -->
         <!-- 能力评估状态 -->
         <el-table-column label="能力评估状态"
                         prop="assessmentStatus"
                         header-align="center"
                         align="center"
                         width="120"
                         :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 评估次数 -->
        <el-table-column label="评估次数"
                         prop="assessTimes"
                         header-align="center"
                         align="center"
                         width="120"
                         :show-overflow-tooltip="true"
        ></el-table-column>
        <!--  用户ID  -->
        <el-table-column label="用户ID"
                         prop="userCode"
                         header-align="center"
                         align="center"
                         width="110"
                         :show-overflow-tooltip="true"
        ></el-table-column>
        <!--员工号-->
        <el-table-column label="员工号"
                         prop="userCardNo"
                         header-align="center"
                         align="center"
                         :show-overflow-tooltip="true"
                         width="110"></el-table-column>
        <!--当前品牌 -->
        <el-table-column label="当前品牌"
                         prop="brand"
                         header-align="center"
                         align="center"
                         width="100"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <!--当前网点类型 -->
        <el-table-column label="当前网点类型"
                         prop="netWorkType"
                         header-align="center"
                         align="center"
                         width="120"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <!--当前经销商集团 -->
        <el-table-column label="当前经销商集团"
                         prop="dealerGroupName"
                         header-align="center"
                         align="center"
                         width="140"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <!-- 操作 -->
        <el-table-column label="操作"
                         fixed="right"
                         header-align="center"
                         align="center"
                         width="100">
          <template slot-scope="scope">
            <el-link type="primary"  :underline="false"
                     @click="sendInfo(scope.row)">发展详情
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     :total="total"
                     layout="total, sizes, prev, pager, next, jumper"
                     @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </div>

  </div>
</template>

<script>
  /**
   * @author zhengf
   */
  import mixinViewModule from '@/mixins/view-module'

  export default {
    name: "developmentCenterList",
    mixins: [mixinViewModule],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      let _this = this
      //这里存放数据
      return {
        mixinViewModuleOptions: {
          getDataListURL: '/acdc/developmencenterresult/queryDevelopCenterResultByPage',
          getDataListIsPage: true,
        },
        moreList: false,
        keyPositionArr: [], // 职位
        dataForm: {
          // jobId: '',//职位id
          // userName: '',//用户
          // roleType: '' //角色
          userName : '',
          positionId : '',
          assessmentResult : '',
          developCenterResult : '',
          courseFinishStatus : '',
          achievementCompetencyResult : '',
          dealerId : '',
          dealerGroupId : '',
          areaCode : '',
          brandCode : '',
          joinPositionStatus : '',
          developEndTime:''
        },
        parentDealerList:[],// 经销商
        parentDealerGroupList:[], // 经销商集团
      // 前端发展中心结果  枚举值：developCenterState
      // 评估中心结果  枚举值：regionalInterviewResult
      // 在岗状态         枚举值：joinPositionStatus
      // 品牌                枚举值：brandCode
      // 区域                枚举值：area
      // 课程完成情况  枚举值：training_status
      // 业绩/能力反馈 枚举值：AchievementCompetencyResult

        keyPositionArrs:[],// 评估职位

        // 发展中心结果
        developCenterState: _this.enums['developCenterStateDC'],
        // 评估中心结果
        regionalInterviewResult: _this.enums['assessmentResultDC'],
        //能力评估状态
        assessmentStatusArr: this.enums["assessmentStatus"],
        // 在岗状态
        joinPositionStatus: _this.enums['joinPositionStatus'],
        // 品牌
        brandCode: _this.enums['brandCode'],
        // 区域
        area: _this.enums['area'],
        // 课程完成情况
        trainingStatus: _this.enums['courseCompletionStatus'],
        // 课程完成情况
        achievementCompetencyResult: _this.enums['achievementCompetencyResult'],





      }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},

    //方法集合
    methods: {
      // 数据初始化
      init() {
        this.getKeyPosition()
      },

      getKeyPosition(){
        // 评估职位
        this.$request.get('/sys/commposition/keyPosition')
          .then((res, total, code, data) => {
            this.keyPositionArrs = res
            this.keyPositionArrs = JSON.parse(JSON.stringify(this.keyPositionArrs))
          }).catch((err) => {
            console.log(err)
        })
      },

      // 查询
      getDataListMerge() {
        this.page = 1
        this.getDataList()
        if (this.$hasPermission('ACDC0000001')) {//acdc管理员
          this.dataForm.roleType = 'acdcAdmin'
        } else if (this.$hasPermission('ACDC0000002')) {//区域经理
          this.dataForm.roleType = 'areaManager'
        }


      },

      // 跳转发展详情页面
      sendInfo(row){
        this.$router.push({
          name: 'acdc-developmentCenter-developmentCenterInfo',
          query: {
            recruitmentId: row.recruitmentId
          }
        })
        this.$eventHub.$emit('showDevelopmentCenterInfo', '')
      },
      // 导出
      exportdevelopment(){
        this.$request.downloadLearning('/acdc/developmencenterresult/export',
          '发展中心列表导出',
          this.dataForm
        )
      },
      // 搜索所属经销商
      parentDealerSearch(queryString) {
        this.$request.get('/sys/org/selectOrg',
          {
            orgType: '50',
            name: queryString
          }).then((res, total, code, data) => {
          this.parentDealerList = res
        }).catch((err) => {
          console.log(err)
        })
      },
      // 搜索所属集团
      parentDealerGroupSearch(queryString) {
        this.$request.get('/sys/org/selectOrg',
          {
            orgType: '40',
            name: queryString
          }).then((res, total, code, data) => {
          this.parentDealerGroupList = res
        }).catch((err) => {
          console.log(err)
        })
      },
      // 重置
      again() {
        this.dataForm.userName = ''
        this.dataForm.positionId = ''
        this.dataForm.assessmentResult = ''
        this.dataForm.developCenterResult = ''
        this.dataForm.courseFinishStatus = ''
        this.dataForm.achievementCompetencyResult = ''
        this.dataForm.dealerId = ''
        this.dataForm.dealerGroupId = ''
        this.dataForm.areaCode = ''
        this.dataForm.brandCode = ''
        this.dataForm.joinPositionStatus = ''

        this.dataForm.achievementCompetencyResult = ''
        this.dataForm.developEndTime = ''

        this.page = 1
        this.getDataList()
      },

    },

    //创建前：
    beforeCreate() {
      console.log('beforeCreate')
    },
    // 创建完成 实例已经创建完成之后被调用
    created() {
      if (this.$hasPermission('ACDC0000001')) {//acdc管理员
        this.dataForm.roleType = 'acdcAdmin'
      } else if (this.$hasPermission('ACDC0000002')) {//区域经理
        this.dataForm.roleType = 'areaManager'
      }


      if (this.$hasPermission('ACDC0000002') && !this.$hasPermission('ACDC0000001')) {
        // TODO 2021-06-17 区域经理去掉默认显示
        // this.$set(this.dataForm,'achievementCompetencyResult','NeedFeedBack')
        // let createDate = new Date()
        // let createYear = createDate.getFullYear()
        // let createMonth = createDate.getMonth() + 1
        // let endOfMonth = new Date(createYear, createMonth, 0).getDate() + ''; // 获取本月最后一天
        // let satrt =  createYear + '-' + createMonth + '-' + '01'
        // let end =  createYear + '-' + createMonth + '-' + endOfMonth
        // let dateVals = [satrt,end]
        // this.$set(this.dataForm,'developEndTime',dateVals)
      }
    },
    //挂载前：在挂载开始之前被调用：相关的 render 函数首次被调用
/*    beforeMount() {
      console.log('beforeMount')
      let arry = []
      for (let i = 0; i < this.area.length; i++) {
        if (this.area[i].dictStatus == '1') {
          arry.push(this.area[i])
        }
      }
        this.area = arry
    },*/
    // 挂载完成：
    mounted() {
      this.init()
    },
    // 即将更新渲染: 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
    beforeUpdate() {
      console.log('beforeUpdate')
    },
    // 更新成功
    updated() {
      console.log('updated')
    },
    // 实例销毁之前调用
    beforeDestroy() {
      console.log('beforeDestroy')
    },
    //Vue 实例销毁后调用
    destroyed() {
      console.log('destroyed')
    }

  }
</script>

<style scoped>
  @import "../../../css/pkg-styles.css";
  /*.search-item {*/
  /*  width: 94%!important;*/
  /*  min-width: 290px;*/
  /*}*/
  /* .search-item .el-form-item__content {*/
  /*  margin-left: 110px !important;*/
  /*}*/

  .row-mar-time {
    padding-left: 20px;
  }
  .search {
    margin-bottom: 10px;
  }
</style>
